// В списках строки в одну строку: что не поместилось, обрезано многоточием.
// По клику такая ячейка разворачивается прямо в строке, повторный клик
// сворачивает (решение владельца 31.10, вместо подсказки при наведении).
// Один обработчик на документ — без правок в каждом списке.

const OPEN = 'is-cell-open';
const CUT = 'is-cell-cut';
const INTERACTIVE = 'a, button, input, select, textarea, label, [role="button"]';
// дальше этого сдвиг мыши — уже выделение текста, а не клик
const DRAG_LIMIT = 3;

let mouseDown = null;
let selfClick = false;

function closedReadMore(cell) {
  return cell.querySelector('.read-more:not(.is-opened)');
}

function isCut(cell) {
  // значок без текста (флаг расположения): разворачивать нечего
  if (!cell.textContent.trim()) {
    return false;
  }
  if (closedReadMore(cell) || cell.scrollWidth > cell.clientWidth + 1) {
    return true;
  }
  return Array.from(cell.querySelectorAll('*'))
    .some(node => node.scrollWidth > node.clientWidth + 1);
}

function getCell(target) {
  const cell = target.closest && target.closest('td.ds-table__cell');

  // строка с вложенной таблицей: разворачиваются её собственные ячейки
  if (!cell || cell.closest('tr').className.includes('variant_expanded')) {
    return null;
  }
  return cell;
}

function rememberText(cell) {
  cell.dataset.openText = cell.textContent;
}

function setOpen(cell, target, open) {
  const readMore = cell.querySelector('.read-more');

  cell.classList.toggle(OPEN, open);

  // текст read-more урезан ещё в разметке — раскрывает он сам:
  // клик по нему и так дойдёт, клик мимо него передаём
  if (readMore && !readMore.contains(target)) {
    selfClick = true;
    readMore.click();
    selfClick = false;
  }

  if (open) {
    // сохраняем уже после того, как read-more подставит весь текст
    setTimeout(() => rememberText(cell));
  }
}

function hasSelection() {
  const selection = window.getSelection ? window.getSelection().toString() : '';
  return Boolean(selection.trim());
}

function wasDragged(event) {
  return Boolean(mouseDown) && (
    Math.abs(event.clientX - mouseDown.x) > DRAG_LIMIT
    || Math.abs(event.clientY - mouseDown.y) > DRAG_LIMIT
  );
}

function handleClick(event) {
  if (selfClick) {
    return;
  }

  const cell = getCell(event.target);

  if (
    !cell
    || event.target.closest(INTERACTIVE)
    || hasSelection()
    || wasDragged(event)
  ) {
    return;
  }

  const open = cell.classList.contains(OPEN);

  if (open || isCut(cell)) {
    setOpen(cell, event.target, !open);
    // разворот ячейки не должен открывать саму строку
    if (!cell.querySelector('.read-more')) {
      event.stopPropagation();
    }
  }
}

function handleHover(event) {
  const cell = getCell(event.target);

  if (!cell) {
    return;
  }

  // текст ячейки сменился (обновление списка) — это уже другая запись
  if (cell.classList.contains(OPEN) && cell.dataset.openText !== cell.textContent) {
    cell.classList.remove(OPEN);
  }

  if (cell.dataset.cutText !== cell.textContent) {
    cell.dataset.cutText = cell.textContent;
    cell.classList.toggle(CUT, isCut(cell));
  }
}

export function installCellTitles() {
  document.addEventListener('mousedown', event => {
    mouseDown = { x: event.clientX, y: event.clientY };
  }, true);
  document.addEventListener('click', handleClick, true);
  document.addEventListener('mouseover', handleHover);
}
